import { inherits as _inherits, createSuper as _createSuper, createClass as _createClass, classCallCheck as _classCallCheck } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import React, { isValidElement } from 'react';
import { fragmentMap } from '../../utils/ReactUtils.js';
import { getInitialViewportSize, addViewportCallback, removeViewportCallback } from '../../utils/windowEvents/ResizeEvents.js';
import { ButtonGroupPresentation } from './ButtonGroupPresentation.js';

var ButtonGroupWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(ButtonGroupWrapper, _React$Component);
  var _super = _createSuper(ButtonGroupWrapper);
  function ButtonGroupWrapper(props) {
    var _this;
    _classCallCheck(this, ButtonGroupWrapper);
    _this = _super.call(this, props);
    _this.updateViewport = function (viewport) {
      _this.setState({
        viewport: viewport
      });
    };
    _this.state = {
      viewport: getInitialViewportSize()
    };
    return _this;
  }
  _createClass(ButtonGroupWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      addViewportCallback(this.updateViewport);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      removeViewportCallback(this.updateViewport);
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
        children = _a.children,
        otherProps = __rest(_a, ["children"]);
      var viewport = this.state.viewport;
      return /*#__PURE__*/React.createElement(ButtonGroupPresentation, Object.assign({}, otherProps, {
        viewport: viewport
      }), fragmentMap(children, function (child) {
        return /*#__PURE__*/isValidElement(child) && /*#__PURE__*/React.cloneElement(child, {
          role: "listitem",
          // avoid full width of buttons in the layer header
          reducedWidthMobile: otherProps.direction === "horizontal"
        });
      }));
    }
  }]);
  return ButtonGroupWrapper;
}(React.Component);
ButtonGroupWrapper.defaultProps = {
  direction: "horizontal"
};

export { ButtonGroupWrapper };
